import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If the email exists, a reset link has been sent");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };
  return (
    <div className="min-h-screen grid place-items-center p-6 bg-background text-foreground">
      <div className="w-full max-w-md">
        <div className="eyebrow text-muted-foreground mb-2">Recovery</div>
        <h1 className="display text-3xl font-semibold tracking-tighter mb-6">Forgot your password?</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <div>
            <Label className="eyebrow text-muted-foreground">Email</Label>
            <Input data-testid="forgot-email-input" value={email} onChange={e => setEmail(e.target.value)} type="email" className="mt-1.5 h-11" />
          </div>
          <Button data-testid="forgot-submit-btn" type="submit" className="w-full h-11">Send reset link</Button>
        </form>
        {sent && <p className="text-xs text-muted-foreground mt-4 mono">Check the backend logs for the reset link (dev mode).</p>}
        <div className="mt-6 text-sm">
          <Link to="/login" className="text-primary hover:underline">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
